import { createSlice } from '@reduxjs/toolkit';

// mining/colo are `null` (not `false`) until the GET features response resolves — the mining
// guard rule (Plan 06 §Key contracts) is `features.mining !== false`, so "not yet loaded" reads
// as visible, keeping mining orgs' UI bit-identical before/after this fetch settles.
const initialState = {
  mining: null,
  colo: null,
  isLoading: false,
  loaded: false,
  error: null
};

const featuresSlice = createSlice({
  name: 'features',
  initialState,
  reducers: {
    requestStart: state => {
      state.isLoading = true;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    fetchFeaturesSuccess: (state, action) => {
      state.mining = action.payload.mining;
      state.colo = action.payload.colo;
      state.isLoading = false;
      state.loaded = true;
    }
  }
});

export const { requestStart, requestFailure, fetchFeaturesSuccess } =
  featuresSlice.actions;

export default featuresSlice.reducer;
